import Menu from './menu';
import MenuItem from './menu-item';
import MenuCheckboxItem from './menu-checkbox-item';
Menu.Item = MenuItem;
Menu.CheckboxItem = MenuCheckboxItem;
export { MenuItem };
export default Menu;
//# sourceMappingURL=index.js.map